import React from 'react';
import { connect } from 'react-redux';
import T from 'prop-types';
import { selectAllShowFeatureFlags, FEATURE_FLAG_LOADED_STATUS } from 'ducks/feature-flags';
import Features from 'app/features';
import history from 'app/history';
import resourceProp from '../../../shared/helpers/resource-prop';
import { Episode } from '../../../resources';
import Form from './components/form';

const AccessSettingPage = (props, context) => {
  const { episode } = context;
  const { featureFlags } = props;
  const { id: episodeId, show: showId } = episode.data;

  const hasAcastAccess = React.useMemo(() => {
    const showFeatureFlags = featureFlags[showId];
    return (
      !!showFeatureFlags &&
      !!showFeatureFlags.flags.find(flag => flag.name === Features.AcastAccess)
    );
  }, [featureFlags, showId]);

  const didLoadShowFeatures = React.useMemo(() => {
    const showFeatureFlags = featureFlags[showId];
    return !!featureFlags && showFeatureFlags.status === FEATURE_FLAG_LOADED_STATUS;
  }, [featureFlags, showId]);

  React.useEffect(() => {
    if (didLoadShowFeatures && !hasAcastAccess) {
      history.get().replace(`/episodes/${episodeId}/settings`);
    }
  }, [didLoadShowFeatures, hasAcastAccess, episodeId]);

  if (!hasAcastAccess) return null;

  return <Form episode={episode} />;
};

AccessSettingPage.propTypes = {
  featureFlags: T.object.isRequired,
};

AccessSettingPage.contextTypes = {
  episode: resourceProp(Episode),
};

export default connect(state => ({
  featureFlags: selectAllShowFeatureFlags(state),
}))(AccessSettingPage);
